import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import * as _ from 'lodash';

@Component({
	selector: 'bt-string-filter-list',
	standalone: true,
	imports: [MatDialogModule, MatIconModule, FormsModule, MatButtonModule, MatInputModule, CommonModule, MatNativeDateModule],
	templateUrl: './string-filter-list.component.html',
	styleUrl: './string-filter-list.component.scss'
})
export class StringFilterListComponent implements OnInit {
	readonly #dialogRef = inject(MatDialogRef<StringFilterListComponent>);
	data = inject(MAT_DIALOG_DATA);

	texts: string = '';

	ngOnInit(): void {
		console.log(this.data);
		this.data = _.cloneDeep(this.data);

		if (!this.data.selected) {
			this.texts = '';
		} else {
			this.texts = this.data.selected;
		}
	}

	apply() {
		this.#dialogRef.close(this.texts);
	}

	onClose(): void {
		this.#dialogRef.close();
	}
}
